import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeTakenPieComponent } from './time-taken-info-pie.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import {SharedModule} from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import {TranslocoModule} from '@jsverse/transloco';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';

@NgModule({
  declarations: [TimeTakenPieComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatProgressSpinnerModule,
    MatIconModule,
    TranslocoModule,
    ReactiveFormsModule,
    NgxEchartsModule.forRoot({
      echarts
    }),
  ],
  exports: [TimeTakenPieComponent] 
})
export class TimeTakenPieModule {}
